import React from 'react';
import { FancyIconButton } from '../../common/buttons';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const OpenStandaloneButton = () => {
  return (
    <FancyIconButton
      variant="secondary"
      size="lg"
      shape="circle"
      ariaLabel="Open in new window"
      onClick={() => window.open('/', '_blank').focus()}
    >
      <OpenInNewIcon />
    </FancyIconButton>
  );
};
